import { MenuItem, MenuList, Paper } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ContextMenu from './ContextMenu'

const SUB_QUERY = {
    MNU_NEW_SUB_QUERY_LINK: 'MNU_NEW_SUB_QUERY_LINK',
    MNU_DEL_SUB_QUERY_LINK: 'MNU_DEL_SUB_QUERY_LINK'
}

function NewSubQuery({ onCreateNewSubQuery = () => {}, onDeleteSubQuery = () => {}, disable }) {
    const { t } = useTranslation();
    const handleClick = (action) => {
        if (action === SUB_QUERY.MNU_NEW_SUB_QUERY_LINK) onCreateNewSubQuery();
        else if (action === SUB_QUERY.MNU_DEL_SUB_QUERY_LINK) onDeleteSubQuery();
    }

    return (
        <ContextMenu targetId="subquery">
            <Paper style={{ width: "19rem" }}>
                <MenuList vertical="true">
                    <MenuItem 
                        name={t("MNU_NEW_SUB_QUERY_LINK")} 
                        onClick={() => handleClick(SUB_QUERY.MNU_NEW_SUB_QUERY_LINK)}
                    >
                        <span className={"QUERY"}></span>
                        <span className={"margin-left-8"}>
                            {t("MNU_NEW_SUB_QUERY_LINK")}
                        </span>
                    </MenuItem>
                    <MenuItem 
                        name={t("MNU_DEL_SUB_QUERY_LINK")} 
                        onClick={() => handleClick(SUB_QUERY.MNU_DEL_SUB_QUERY_LINK)}
                        disabled={disable}
                    >
                        <span className={"SYMBOL_DELETE"}></span>
                        <span className={"margin-left-8"}>{t("MNU_DEL_SUB_QUERY_LINK")}</span>
                    </MenuItem>
                </MenuList>
            </Paper>
        </ContextMenu>
    )
}

export default NewSubQuery